import { useEffect, useRef, useState } from 'react';

function Reveal({
  children,
  delay = 0,
  variant = 'up',
  className = '',
  style,
  as: Tag = 'div',
  ...rest
}) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;

    let rafId1;
    let rafId2;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          // Defer by two frames so the browser has painted the hidden
          // (opacity: 0) state at least once before we flip to visible —
          // otherwise elements already in view on load (large screens,
          // zoomed-out browsers) can jump straight to visible with no
          // perceptible transition.
          rafId1 = requestAnimationFrame(() => {
            rafId2 = requestAnimationFrame(() => setVisible(true));
          });
          observer.unobserve(el);
        }
      },
      { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
    );

    observer.observe(el);
    return () => {
      observer.disconnect();
      cancelAnimationFrame(rafId1);
      cancelAnimationFrame(rafId2);
    };
  }, []);

  return (
    <Tag
      ref={ref}
      className={`reveal reveal-${variant} ${visible ? 'reveal-visible' : ''} ${className}`}
      style={{ ...style, transitionDelay: `${delay}ms` }}
      {...rest}
    >
      {children}
    </Tag>
  );
}

export default Reveal;
